import request from '@/utils/request'

const order = {
  name: 'order',
  state: {
    isOrderDetailLoading: false,
    orderDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_ORDER_DETAIL_LOADING: (state, data) => {
      state.isOrderDetailLoading = data
    },
    SET_MODULES_ORDER_DETAIL_DATA: (state, data) => {
      state.orderDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryOrderDetailData({ commit }, id) {
      commit('SET_IS_MODULES_ORDER_DETAIL_LOADING', true)
      commit('SET_MODULES_ORDER_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/order/orderDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_ORDER_DETAIL_LOADING', false)
          commit('SET_MODULES_ORDER_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_ORDER_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetOrderDetailData({ commit }) {
      commit('SET_MODULES_ORDER_DETAIL_DATA', {})
    },
    //  重置账号新增页面数据
    setOrderDetailData({ commit }, data) {
      commit('SET_MODULES_ORDER_DETAIL_DATA', data)
    }
  }
}

export default order
